/* eslint-disable react/forbid-prop-types */
import React, {
  FC,
} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { IAppState } from '../../../../state/reducers';
import { IExchangeSchedule } from '../../../../api/vault/exchangeSchedule';

const MetadataContainer = styled.div`
  height: 20px;
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: 700;
`;

const options = {
  year: 'numeric' as const,
  month: 'short' as const,
  day: 'numeric' as const,
};

const PropertyName = styled.span`
  color: gray;
  font-weight: 400;
`;

const PropertyValue = styled.span`
  margin-left: 3px; 
`;

const PropertySpacer = styled.span`
  margin-left: 5px; 
  margin-right: 5px;
`;

const Spacer = styled.div`
  height: 20px;
`;

interface IStateProps {
  assetDetails: any;
  isExchangeLiveEvent: boolean;
  exchangeSchedule: IExchangeSchedule;
}

interface IProps extends IStateProps { }

/* Make these tag names driven from MetaTags collection in mongo
(or at least localize tag names) */
const VideoPlayerMetadata: FC<IProps> = (props: IProps) => {
  const { assetDetails, exchangeSchedule, isExchangeLiveEvent } = props;
  if (isExchangeLiveEvent) {
    return (
      <div>
        <MetadataContainer>
          <PropertyName>Date of Game:</PropertyName>
          <PropertyValue>{exchangeSchedule?.GameDate ? `${new Date(exchangeSchedule.GameDate).toLocaleDateString('en-US', options)}` : 'None'}</PropertyValue>
          <PropertySpacer>|</PropertySpacer>
          <PropertyName>Sport:</PropertyName>
          <PropertyValue>{exchangeSchedule?.Sport ? `${exchangeSchedule.Sport}` : 'None'}</PropertyValue>
          <PropertySpacer>|</PropertySpacer>
          <PropertyName>Season:</PropertyName>
          <PropertyValue>{exchangeSchedule?.Season ? `${exchangeSchedule.Season}` : 'None'}</PropertyValue>
          <PropertySpacer>|</PropertySpacer>
          <PropertyName>League:</PropertyName>
          <PropertyValue>{exchangeSchedule?.League ? `${exchangeSchedule.League}` : 'None'}</PropertyValue>
          <PropertySpacer>|</PropertySpacer>
          <PropertyName>Game Type:</PropertyName>
          <PropertyValue>{exchangeSchedule?.GameType ? `${exchangeSchedule.GameType}` : 'None'}</PropertyValue>
        </MetadataContainer>
        <MetadataContainer>
          <PropertyName>Game Number:</PropertyName>
          <PropertyValue>{exchangeSchedule?.NCAAGameNumber ? `${exchangeSchedule.NCAAGameNumber}` : 'None'}</PropertyValue>
          <PropertySpacer>|</PropertySpacer>
          <PropertyName>Home:</PropertyName>
          <PropertyValue>{exchangeSchedule?.HomeTeamName ? `${exchangeSchedule.HomeTeamName}` : 'None'}</PropertyValue>
          <PropertySpacer>|</PropertySpacer>
          <PropertyName>Away:</PropertyName>
          <PropertyValue>{exchangeSchedule?.VisitorTeamName ? `${exchangeSchedule.VisitorTeamName}` : 'None'}</PropertyValue>
        </MetadataContainer>
        <Spacer />
      </div>
    );
  }
  return (
    <>
      <MetadataContainer id="VideoPlayerMetadata">
        <PropertyName>Sport:</PropertyName>
        <PropertyValue id="VideoPlayerMetadataSport">{assetDetails?.sport ? `${assetDetails.sport}` : 'None'}</PropertyValue>
        <PropertySpacer>|</PropertySpacer>
        <PropertyName>Video Type:</PropertyName>
        <PropertyValue id="VideoPlayerMetadataType">{assetDetails?.type ? `${assetDetails.type}` : 'None'}</PropertyValue>
        <PropertySpacer>|</PropertySpacer>
        <PropertyName>Date of Game:</PropertyName>
        <PropertyValue id="VideoPlayerMetadataGameDate">{assetDetails?.gameDate ? `${new Date(assetDetails.gameDate).toLocaleDateString('en-US', options)}` : 'None'}</PropertyValue>
        <PropertySpacer>|</PropertySpacer>
        <PropertyName>Home:</PropertyName>
        <PropertyValue id="VideoPlayerMetadataHomeTeam">{assetDetails?.homeTeam ? `${assetDetails.homeTeam}` : 'None'}</PropertyValue>
        <PropertySpacer>|</PropertySpacer>
        <PropertyName>Away:</PropertyName>
        <PropertyValue id="VideoPlayerMetadataAwayTeam">{assetDetails?.awayTeam ? `${assetDetails.awayTeam}` : 'None'}</PropertyValue>
      </MetadataContainer>
      <Spacer />
    </>
  );
};

const mapStateToProps = (state: IAppState): IStateProps => ({
  assetDetails: state.clipperMediaContent.assetDetails,
  isExchangeLiveEvent: state.clipperMediaContent.isExchangeLiveEvent,
  exchangeSchedule: state.clipperMediaContent.exchangeSchedule,
});

export default connect(
  mapStateToProps,
  null,
)(VideoPlayerMetadata);
